import React, { useState } from "react";
import "./CharacterGallery.css"; // 导入样式文件
import c1 from "./arcaea/c1.png";
import c2 from "./arcaea/c2.png";
import c3 from "./arcaea/c3.png";
import c4 from "./arcaea/c4.png";
import c5 from "./arcaea/c5.png";
import c6 from "./arcaea/c6.png";
import c7 from "./arcaea/c7.png";
import c8 from "./arcaea/c8.png";
import c9 from "./arcaea/c9.png";
import c10 from "./arcaea/c10.png";
import c11 from "./arcaea/c11.png";
import c12 from "./arcaea/c12.png";

const Character = ({ name, image, description, onClick }) => {
  return (
    <div className="character" onClick={onClick}>
      <img src={image} alt={name} />
      <div className="profile">
        <subtitle>{name}</subtitle>
        <p>{description}</p>
      </div>
    </div>
  );
};

const CharacterGallery = () => {
  const [selectedCharacter, setSelectedCharacter] = useState(null);

  const characters = [
    {
      id: 1,
      name: "Hikari",
      image: c1,
      description: "Hikari" + "'" + 's name means "light" in Japanese.',
    },
    {
      id: 2,
      name: "Tairitsu",
      image: c2,
      description: "Tairitsu" + "'" + 's name means "conflict" in Japanese.',
    },
    {
      id: 3,
      name: "Kou",
      image: c3,
      description:
        'Kou has been officially described as "a cheery girl with a long history in the world of Arcaea".',
    },
    {
      id: 4,
      name: "Lethe",
      image: c4,
      description:
        '"Lethe" (λήθη) is an Ancient Greek word that means "oblivion" or "forgetfulness".',
    },
    {
      id: 5,
      name: "Eto",
      image: c5,
      description:
        '"Eto comes from French "étoile", which means "star". Eto has been officially described as "amiable".',
    },
    {
      id: 6,
      name: "Luna",
      image: c6,
      description:
        "Luna is much more affectionate towards her twin sister, Eto, however, as shown in the Binary Enfold story.",
    },
    {
      id: 7,
      name: "Ayu",
      image: c7,
      description:
        "Ayu has been described by Sowiti to be, in their personal opinion, carefree, energetic, and comfortable.",
    },
    {
      id: 8,
      name: "Saya",
      image: c8,
      description:
        "Saya is a very inquisitive person and is content to find out how and why everything works in the first place.",
    },
    {
      id: 9,
      name: "Kanae",
      image: c9,
      description:
        "Kanae's name, 叶永, contains the characters 叶 (to grant wishes) and 永 (forever).",
    },
    {
      id: 10,
      name: "Shirahime",
      image: c12,
      description: 'Shirahime means "white princess" in Japanese.',
    },
    {
      id: 11,
      name: "Alice & Tenniel",
      image: c10,
      description:
        "Alice is likely named after Alice's Adventures in Wonderland (1865), while Tenniel's name likely originates from the illustrator of the novel.",
    },
    {
      id: 12,
      name: "Lagrange",
      image: c11,
      description:
        "Lagrange is a calm, curious and observant person, often observing and questioning to see how the world Arcaea around her works.",
    },
  ];

  const handleCharacterClick = (character) => {
    if (selectedCharacter === character) {
      // If the same character is clicked again, deselect it
      setSelectedCharacter(null);
    } else {
      setSelectedCharacter(character);
    }
  };

  return (
    <div className="gallery">
      <div className="characters">
        {characters.map((character) => (
          <Character
            key={character.id}
            name={character.name}
            image={character.image}
            description={character.description}
            onClick={() => handleCharacterClick(character)}
          />
        ))}
      </div>
    </div>
  );
};

export default CharacterGallery;
